import React from 'react';
import {Route, Redirect } from 'react-router-dom';
import {userIsInGroup, READ_ONLY_GROUP,EDITORS_GROUP,DRIVER_GROUP} from '../../utils/groups';
import ForbiddenPage from './../../views/ForbiddenPage';
import DriverForbbidenPage from './../../views/DriverForbbidenPage';

const EditorsRoute = ({children,isLoggedIn,user, readOnlyComponent,...rest}) =>(
        <Route
            {...rest}
            render={(routerProps) =>{
                if(user){
                    if(isLoggedIn){
                        if(userIsInGroup(user,EDITORS_GROUP)){
                            const childrenWithMatch = React.Children.map(children, child => 
                                React.cloneElement(child,routerProps));
                            return (childrenWithMatch)
                        } else if (userIsInGroup(user,READ_ONLY_GROUP)) {
                            if(readOnlyComponent){
                                const readOnlyComponentWithMatch = React.Children.map(readOnlyComponent, child => 
                                    React.cloneElement(child,routerProps));
                                return (readOnlyComponentWithMatch)
                            } else {
                                return <ForbiddenPage/>
                            }
                        } else if (userIsInGroup(user,DRIVER_GROUP)) {
                            return(<DriverForbbidenPage/>);
                        } else {
                            return(<ForbiddenPage/>)
                        }
                    }
                    else {
                        return (<Redirect to='/login'/>);
                    }
                    
                } else {
                    return (<Redirect to='/login'/>);
                }
            }}
        />
    );


export default EditorsRoute;